import { Component } from '@angular/core';
import { MedrecordIcon } from '../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-arrow-left',
  templateUrl: './arrow-left.component.svg',
})
export class ArrowLeftComponent extends MedrecordIcon {
  viewHeight = 15;
  viewWidth = 16;
}
